// useCreateOrganization.ts

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { addOrganization } from '../services/apiUsers.ts';
import { toast } from '../utils/sweetAlert.ts';

export function useCreateOrganization() {
  const queryClient = useQueryClient();

  const { isLoading: isCreating, mutate: createOrganization } = useMutation({
    mutationFn: (newOrg: { name: string; address: string; email: string; phone: string }) =>
      addOrganization(newOrg.name, newOrg.address, newOrg.email, newOrg.phone),
    onSuccess: () => {
      queryClient.invalidateQueries(['organizations']);
      toast('success', 'The organization was successfully created!');
    },
    onError: (error: any) => {
      toast('error', `Something went wrong! ${error.message}`);
    },
  });

  return { isCreating, createOrganization };
}
